import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["p", "br", "strong", "b", "em", "i", "u", "a", "ul", "ol", "li"];
const ALLOWED_ATTR = ["href", "target", "rel"];

/** Sanitize rich-text HTML for storage and display. */
export function sanitizeHtml(html) {
  if (html == null || html === "") return "";
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}

let linkHookInstalled = false;
function ensureLinkHook() {
  if (linkHookInstalled || typeof window === "undefined" || !DOMPurify.addHook) return;
  linkHookInstalled = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
}
ensureLinkHook();

/** Strip tags and decode to plain text length for validation/clamps. */
export function plainTextLength(html) {
  return plainTextFromHtml(html).length;
}

export function plainTextFromHtml(html) {
  if (html == null || html === "") return "";
  const str = String(html);
  if (typeof document !== "undefined") {
    const tmp = document.createElement("div");
    tmp.innerHTML = sanitizeHtml(str);
    return (tmp.textContent || tmp.innerText || "").replace(/\u00a0/g, " ").trim();
  }
  return str.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

/** True when editor content is empty or only empty paragraphs. */
export function isEmptyHtml(html) {
  if (html == null || html === "") return true;
  const plain = plainTextFromHtml(html);
  if (plain.length > 0) return false;
  // No text but maybe only empty tags
  const stripped = String(html)
    .replace(/<br\s*\/?>/gi, "")
    .replace(/<p>\s*<\/p>/gi, "")
    .replace(/&nbsp;/gi, "")
    .replace(/\s+/g, "");
  return stripped.length === 0 || /^<p><\/p>$/i.test(stripped);
}

/** Normalize for API: empty → null, else sanitized HTML. */
export function htmlForApi(html) {
  if (isEmptyHtml(html)) return null;
  return sanitizeHtml(html);
}

/** Detect if string looks like HTML markup. */
export function looksLikeHtml(value) {
  if (value == null || value === "") return false;
  return /<\/?[a-z][\s\S]*>/i.test(String(value));
}
